/* eslint-disable consistent-return */

function getOffersRowMapping(offerType) {
	if (offerType === 'refinance') {
		const refinanceRowMapping = [
			'totalLoanAmount',
			'monthlyMortgagePayment',
			'totalCostOfDebt',
			'closingCost',
			'interestRate',
			'remainingMonth'
		];

		return refinanceRowMapping;
	}
	if (offerType === 'new_loan') {
		const newLoanRowMapping = [
			'totalLoanAmount',
			'monthlyPayUsd',
			'totalCostOfDebt',
			'closingCost',
			'interestRate',
			'tenure'
		];

		return newLoanRowMapping;
	}

	if (offerType === 'cash_out') {
		const cashOutRowMapping = [
			'totalCashOutAmount',
			'monthlyMortgagePayment',
			'totalCostOfDebt',
			'interestRate',
			'remainingMonth'
		];

		return cashOutRowMapping;
	}
}

export default getOffersRowMapping;
